//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as shopCarOrderApi from '@/api/shopCarOrderApi';
export default {
  name: 'ShopCarOrderDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      beansDialogVisible: false
    };
  },
  methods: {
    open: function open(orderNo) {
      var _this = this;
      if (!orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      this.visible = true;
      this.loading = true;
      this.detail = {};
      this.beansDialogVisible = false;
      shopCarOrderApi.getShopCarOrderDetail(orderNo).then(function (res) {
        _this.detail = res;
      }).catch(function (err) {
        console.error('获取订单详情失败:', err);
        _this.$message.error(err && err.message || '获取订单详情失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.detail = {};
      this.beansDialogVisible = false;
    },
    handleViewBeans: function handleViewBeans() {
      this.beansDialogVisible = true;
    },
    getOrderStatusType: function getOrderStatusType(statusName) {
      if (!statusName) return '';
      var status = statusName.toLowerCase();
      if (status.includes('成功') || status.includes('完成') || status.includes('已支付')) {
        return 'success';
      }
      if (status.includes('待') || status.includes('处理中')) {
        return 'warning';
      }
      if (status.includes('失败') || status.includes('取消') || status.includes('关闭')) {
        return 'info';
      }
      if (status.includes('退款')) {
        return 'danger';
      }
      return '';
    }
  }
};